/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".buttons-container{display:flex;flex-direction:row;justify-content:flex-start}.button-container{padding-right:12px;padding-bottom:25px}"];
export { styles as styles };
